import React, {Component} from 'react';
import classNames from 'classnames';
import Paging from './common/Paging.react.js';

import i18n from "i18next";

class MainHeader extends Component {
    render() {
        return (
            <div className="header mainHeader">
                <div className="header-left pull-left">
                    <div className="toTablePage">
                        <img src={require("../images/overview/paid_title.png")}/>
                        <span className="large tableNameLabel">{i18n.t("pos.header.overview")}</span>
                        <span className="large tableName"></span>
                    </div>
                    <span className="tableSelectBtn">
                                {i18n.t("pos.order.table.select")}
                            </span>
                </div>

                <div className="header-center hidden">
                    <div className="pull-left sc-wrapper vcenter">
                            <span className="quickOrder">
                            <input type="text" className="form-control sc-input input-lg" autoFocus="autofocus"
                                   placeholder={i18n.t("pos.menu.item.short.code")}/>
                            </span>
                        <span>
                                <button className="btn btn-success sc-confirm unusual btn-lg" type="button">
                                    {i18n.t("pos.confirm")}
                                </button>
                            </span>
                    </div>

                    <div className="submitBillBtn">
                        <button className="btn btn-lg bill-submit" style={{marginTop: 0, marginRight: 15}}>
                            <img src={require("../images/pos/order.png")}/>
                            {i18n.t("pos.order.submit")}
                        </button>
                    </div>
                    <span className="title vcenter">
                            <span className="small amount-title">{i18n.t("pos.order.bill.total.amount")}</span>
                            <span className="symbol small">￥</span>
                            <span className="totalPrice large">0</span>
                        </span>
                </div>
            </div>
        );
    }
}

export default class OrderView extends Component {
    render() {
        return (
            <div id="order"
                 className={classNames('state', 'hidden', {experienceRestaurantDialogBottom: this.props.isExp})}
                 tabIndex="0">
                <div className="main">
                    <div className="leftPanel">
                        <MainHeader/>

                        <div className="diner-level">
                            <span className="diner-count">{i18n.t("pos.printer.receipt.diner.total.count.label")}</span>
                            <span className="quantity-editor">
                        <buttom className="btn minus-btn v-m"></buttom>
                        <input type="text" className="quantity-input v-m" value="1" maxLength="2" size="2" disabled/>
                            <buttom className="btn plus-btn v-mbtn plus-btn v-m"></buttom>
                        </span>
                        </div>

                        <div className="orderLeft"></div>
                        <div className="submitBtnDiv">
                            <span className="title vcenter">
                                <span className="small amount-title">{i18n.t("pos.order.bill.total.amount")}</span>
                                <span className="symbol small">￥</span>
                                <span className="totalPrice large">0</span>
                            </span>

                            <span className="submitBillBtn">
                                <button className="btn btn-cancel">
                                    <i className="glyphicon glyphicon-chevron-left"/>
                                </button>
                                <button className="btn btn-lg bill-submit">
                                    {i18n.t("pos.order.submit")}
                                </button>

                            </span>
                        </div>
                    </div>

                    <div className="orderMain">
                    </div>
                    <div className="orderFooter">
                        <button className="btn btn-lg confirm-order">{i18n.t("pos.order.continue")} <span
                            className="symbol">￥</span>
                            <span className="totalPrice large">0</span><span className="itemCount">0</span></button>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/react/OrderView.react.js